import { getUser } from '../../modules/contexts/Auth/RequireAuth';
import httpClient from '../httpClient';

//Busca todos os Logs Acessos por usuario
export async function getLogsAcessos() {
  try {
    const user = getUser();
    const userID = user.sub;

    const response = await httpClient.get(`/api/logacesso/user/${userID}`);

    // Verifica se a resposta da API contém o array `logsAcessos`
    if (Array.isArray(response.data)) {
      return response.data;
    } else if (Array.isArray(response.data.logsAcessos)) {
      return response.data.logsAcessos;
    } else {
      console.error('Estrutura de dados inesperada:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Erro ao obter lista de Logs Acessos:', error);
    throw new Error('Erro ao obter lista de Logs Acessos: ' + error);
  }
}

//Busca todos os Logs Acessos
export async function getAllLogsAcessos() {
  try {
    // const user = getUser();
    //const userID = user.sub;

    const response = await httpClient.get(`/api/logacesso`);

    // Verifica se a resposta da API contém o array `logsAcessos`
    if (Array.isArray(response.data)) {
      return response.data;
    } else if (Array.isArray(response.data.logsAcessos)) {
      return response.data.logsAcessos;
    } else {
      console.error('Estrutura de dados inesperada:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Erro ao obter lista de Logs Acessos:', error);
    throw new Error('Erro ao obter lista de Logs Acessos: ' + error);
  }
}
